import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import { kebabCase } from 'lodash';

import withMessages from '../../utilities/intl';

import Spinner from '../LoadingIndicator/Spinner';

import styles from './splitview.scss';
import './SplitViewAssetReview.scss';

const BASE_KEY = 'components.split_view.review';

function SplitViewAssetReviewComponent({
    getMessage, reviewState, onChange, REVIEW_STATUSES, isProcessing, isHideDropdownList,
}) {
    const DROPDOWN_VALUES = {
        SELECT_TAG: { id: 'select_tag', value: 'tag' },
        REVIEWED: { id: 'reviewed', onChange: REVIEW_STATUSES.REVIEWED },
        NEEDS_REVIEW: { id: 'needs_review', onChange: REVIEW_STATUSES.NEEDS_REVIEW },
        REMOVE_TAG: { id: 'remove', onChange: REVIEW_STATUSES.NO_REVIEW_STATE },
    };

    function renderDropdownListElem(value) {
        const text = getMessage(`${BASE_KEY}.${value.id}`);

        return (
            <span
                role="presentation"
                className={styles['dropdown-item-normal']}
                onClick={() => onChange(value.onChange)}
                key={value.id}
            >
                <span className={styles[`item-${kebabCase(value.id)}`]} title={text}>
                    {text}
                </span>
            </span>
        );
    }

    function renderDropdownList() {
        if (reviewState === REVIEW_STATUSES.REVIEWED) {
            return [
                renderDropdownListElem(DROPDOWN_VALUES.NEEDS_REVIEW),
                renderDropdownListElem(DROPDOWN_VALUES.REMOVE_TAG),
            ];
        } else if (reviewState === REVIEW_STATUSES.NEEDS_REVIEW) {
            return [
                renderDropdownListElem(DROPDOWN_VALUES.REVIEWED),
                renderDropdownListElem(DROPDOWN_VALUES.REMOVE_TAG),
            ];
        }

        return [
            renderDropdownListElem(DROPDOWN_VALUES.NEEDS_REVIEW),
            renderDropdownListElem(DROPDOWN_VALUES.REVIEWED),
        ];
    }

    function renderDropdownTextElem(value) {
        const className = value.value || kebabCase(value.id);

        return (
            <span
                className={styles[`dropdown-title-${className}`]}
            >
                {getMessage(`${BASE_KEY}.${value.id}`)}
            </span>
        );
    }

    function renderDropdownText() {
        switch (reviewState) {
        case REVIEW_STATUSES.REVIEWED:
            return renderDropdownTextElem(DROPDOWN_VALUES.REVIEWED);
        case REVIEW_STATUSES.NEEDS_REVIEW:
            return renderDropdownTextElem(DROPDOWN_VALUES.NEEDS_REVIEW);
        default:
            return renderDropdownTextElem(DROPDOWN_VALUES.SELECT_TAG);
        }
    }


    return (
        <span className={styles['splitview-window-review']} style={{ position: 'relative', opacity: isHideDropdownList ? 0.5 : 1 }}>
            {
                isProcessing &&
                <div className="progress-indicator">
                    <Spinner />
                </div>
            }
            <span className={styles.dropdown}>
                {renderDropdownText()}
                {
                    !isProcessing &&
                    <span className={styles['dropdown-box']}>
                        <span className={styles['dropdown-menu-white']}>
                            {!isHideDropdownList && renderDropdownList()}
                        </span>
                    </span>
                }
            </span>
        </span>
    );
}

SplitViewAssetReviewComponent.propTypes = {
    reviewState: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
    REVIEW_STATUSES: PropTypes.object.isRequired,
    getMessage: PropTypes.func,
    isProcessing: PropTypes.bool,
    isHideDropdownList: PropTypes.bool.isRequired,
};

SplitViewAssetReviewComponent.defaultProps = {
    isHideDropdownList: false,
    getMessage: () => {},
    isProcessing: false,
};

const SplitViewAssetReview = withMessages(SplitViewAssetReviewComponent);
SplitViewAssetReview.displayName = displayName('SplitView/SplitViewAssetReview');

export default SplitViewAssetReview;
